import Project from "../project";


export default function projectSetWorkdayDuration(project:Project, value:number|null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (value === 0) {
        project.startDate   = null
        project.endDate     = null
        return;
    }

    const startDate     = project.startDate ? project.startDate : momentDate()
    const endDate       = project.workSchedule.calculateEndDate(startDate, value);

    project.updateStartEnd(startDate, endDate)
}








